import { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { X } from "lucide-react";

// Custom marker icons
const greenIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const orangeIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-orange.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const blueIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export function GpsMiniMap({ clockInLoc, clockOutLoc, locStatus, onClose }) {
  const markers = [];

  if (clockInLoc?.lat && clockInLoc?.lng) {
    markers.push({
      pos: [clockInLoc.lat, clockInLoc.lng],
      label: "Einstempeln",
      address: clockInLoc.address || "",
      icon: locStatus === "vor_ort" ? greenIcon : locStatus === "ausserhalb" ? orangeIcon : blueIcon,
    });
  }

  if (clockOutLoc?.lat && clockOutLoc?.lng) {
    markers.push({
      pos: [clockOutLoc.lat, clockOutLoc.lng],
      label: "Ausstempeln",
      address: clockOutLoc.address || "",
      icon: blueIcon,
    });
  }

  if (markers.length === 0) return null;

  const center = markers[0].pos;
  const bounds = markers.length > 1
    ? L.latLngBounds(markers.map((m) => m.pos)).pad(0.3)
    : null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40" onClick={onClose} data-testid="gps-minimap-overlay">
      <div
        className="bg-white rounded-lg shadow-2xl overflow-hidden w-[480px] max-w-[90vw]"
        onClick={(e) => e.stopPropagation()}
        data-testid="gps-minimap-container"
      >
        <div className="flex items-center justify-between px-3 py-2 border-b border-gray-200 bg-gray-50">
          <div className="flex items-center gap-2">
            <span className="text-[12px] font-semibold text-gray-700">GPS Standort</span>
            {locStatus && (
              <span className={`text-[10px] px-1.5 py-0.5 rounded font-medium ${
                locStatus === "vor_ort" ? "bg-green-100 text-green-700" : "bg-orange-100 text-orange-700"
              }`}>
                {locStatus === "vor_ort" ? "Vor Ort" : "Ausserhalb"}
              </span>
            )}
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700" data-testid="gps-minimap-close">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div style={{ height: 300 }}>
          <MapContainer
            center={center}
            zoom={15}
            bounds={bounds}
            style={{ height: "100%", width: "100%" }}
            scrollWheelZoom={true}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {markers.map((m, i) => (
              <Marker key={i} position={m.pos} icon={m.icon}>
                <Popup>
                  <div className="text-[11px]">
                    <strong>{m.label}</strong>
                    {m.address && <p className="text-gray-600 mt-0.5">{m.address}</p>}
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
        <div className="px-3 py-2 border-t border-gray-100 text-[10px] text-gray-500 space-y-0.5">
          {clockInLoc?.address && <p><span className="font-medium text-gray-600">Start:</span> {clockInLoc.address}</p>}
          {clockOutLoc?.address && <p><span className="font-medium text-gray-600">Ende:</span> {clockOutLoc.address}</p>}
        </div>
      </div>
    </div>
  );
}
